define('TescoMobile_BoPo/js/stock-status-lookup',[], function () {
  'use strict';

  return {
    'TescoMobile_BoPo/js/stock-status-lookup': function (config) {
      this.preorderInStock = config.preorder_in_stock;
      this.backorderInStock = config.backorder_in_stock;
      this.preorderOutOfStock = config.preorder_out_of_stock;
      this.backorderOutOfStock = config.backorder_out_of_stock;
    }
  };
});

